import React from "react";

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

export const Placeholder = ({ placeholderText, height }) => {

 return (
  <Box
   sx={{
    width: "100%",
    height: height || "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
   }}
  >
   <Typography
    variant="h5"
    noWrap
    sx={{
     mr: 2,
     display: { xs: "none", md: "flex" },
     fontWeight: 700,
     letterSpacing: ".3rem",
     textDecoration: "none",
    }}
    color="secondary"
   >
    {placeholderText}
   </Typography>
  </Box>
 );
};
